import { Box, Grid } from '@mui/material';
import Loading from '@/components/general/Loading';
import PageTitle from '@/components/general/PageTitle';
import ListOfNextCheckinsStyles from '@/components/NextCheckinsList';
import TableOfCheckins from '@/components/TableOfCheckins';
import UnreviewedCheckinDetails from '@/components/UnreviewedCheckinDetails';
import UnreviewedCheckinsByTeams from '@/components/UnreviewedCheckinsByTeams';
import { UnreviewedCheckinsByTeamsProps } from '@/components/UnreviewedCheckinsByTeams/UnreviewedCheckinsByTeams.component';
import UnreviewedCheckinsTabs from '@/components/UnreviewedCheckinsTabs';
import { UnreviewedCheckinsTabsProps } from '@/components/UnreviewedCheckinsTabs/UnreviewedCheckinsTabs.component';
import { UnreviewedCheckinsTabsKeys } from '@/types';
import { UserCheckin, CheckinSummary } from '@/types/api';
import styles from './CheckinsUnreviewed.styles';

type CheckinsUnreviewedComponentProps = UnreviewedCheckinsByTeamsProps &
  UnreviewedCheckinsTabsProps & {
    isReviewing: boolean;
    currentCheckin: UserCheckin;
    nextCheckins: CheckinSummary[];
    totalPeopleToBeReminded: number;
    refetchCheckins: () => void;
    handleMarkAsReviewed: (checkinId: string) => void;
    handlePostFeedback: (checkinid: string, feedback?: string) => void;
    handleNotifyEveryone: () => void;
    handleNotifyTeam: (id: string) => void;
    checkinsHistory: CheckinSummary[];
  };

const CheckinsUnreviewedComponent = function ({
  AllUnreviewedCheckins,
  handleStartReviewingCheckins,
  isReviewing,
  handleChangeView,
  view,
  checkinsHistory,
  checkinsByTeamsList,
  nextCheckins,
  currentCheckin,
  handlePostFeedback,
  refetchCheckins,
  handleMarkAsReviewed,
  totalPeopleToBeReminded,
  handleNotifyEveryone,
  handleNotifyTeam,
}: CheckinsUnreviewedComponentProps): JSX.Element {
  return (
    <div>
      <Box>
        <Box sx={styles.pageTitle}>
          <PageTitle title={`${view} Check-ins`} />
        </Box>
        {!isReviewing && (
          <>
            <UnreviewedCheckinsTabs
              handleStartReviewingCheckins={handleStartReviewingCheckins}
              AllUnreviewedCheckins={AllUnreviewedCheckins}
              handleChangeView={handleChangeView}
              view={view}
              totalPeopleToBeReminded={totalPeopleToBeReminded}
              handleNotifyEveryone={handleNotifyEveryone}
            />

            {view === UnreviewedCheckinsTabsKeys.TEAM && (
              <UnreviewedCheckinsByTeams
                handleStartReviewingCheckins={handleStartReviewingCheckins}
                checkinsByTeamsList={checkinsByTeamsList}
                handleNotifyTeam={handleNotifyTeam}
              />
            )}

            {view === UnreviewedCheckinsTabsKeys.EVERYONE && (
              <TableOfCheckins checkins={AllUnreviewedCheckins} />
            )}
          </>
        )}

        {isReviewing && !currentCheckin?.id && <Loading fullPage />}

        {isReviewing && !!currentCheckin?.id && (
          <Grid container spacing={2}>
            <Grid item xs={12} md={9}>
              <Box sx={{ marginTop: -2 }}>
                <UnreviewedCheckinDetails
                  reviewButtonLabel={nextCheckins.length ? 'Next Check-in' : 'Finish Revewing'}
                  refetchCheckin={refetchCheckins}
                  dueDate={currentCheckin?.dueDate}
                  answeredAt={currentCheckin?.answeredAt}
                  user={currentCheckin?.user}
                  answers={currentCheckin?.answers ?? []}
                  isCheckinReviewed={!!currentCheckin?.reviewedAt}
                  checkinId={currentCheckin?.id}
                  feedbacks={currentCheckin?.feedbacks}
                  handlePostFeedback={(feedback) => handlePostFeedback(currentCheckin.id, feedback)}
                  handleMarkAsReviewed={() => {
                    handleMarkAsReviewed(currentCheckin.id);
                  }}
                />
              </Box>
            </Grid>
            {!!currentCheckin?.id && (
              <Grid item xs={12} md={3}>
                <ListOfNextCheckinsStyles checkinsHistory={checkinsHistory} />
              </Grid>
            )}
          </Grid>
        )}
      </Box>
    </div>
  );
};

export default CheckinsUnreviewedComponent;
